/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VoucherCode } from './VoucherCode';
/**
 * 
 * @export
 * @interface Voucher
 */
export interface Voucher {
    /**
     * 
     * @type {number}
     * @memberof Voucher
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof Voucher
     */
    customer?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof Voucher
     */
    expirationDate?: Date | null;
    /**
     * 
     * @type {Array<VoucherCode>}
     * @memberof Voucher
     */
    voucherCodes?: Array<VoucherCode> | null;
}

/**
 * Check if a given object implements the Voucher interface.
 */
export function instanceOfVoucher(value: object): value is Voucher {
    return true;
}

export function VoucherFromJSON(json: any): Voucher {
    return VoucherFromJSONTyped(json, false);
}

export function VoucherFromJSONTyped(json: any, ignoreDiscriminator: boolean): Voucher {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'customer': json['customer'] == null ? undefined : json['customer'],
        'expirationDate': json['expirationDate'] == null ? undefined : (new Date(json['expirationDate'])),
        'voucherCodes': json['voucherCodes'] == null ? undefined : ((json['voucherCodes'] as Array<any>).map((require('./VoucherCode') as typeof import('./VoucherCode')).VoucherCodeFromJSON)),
    };
}

export function VoucherToJSON(json: any): Voucher {
    return VoucherToJSONTyped(json, false);
}

export function VoucherToJSONTyped(value?: Voucher | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'customer': value['customer'],
        'expirationDate': value['expirationDate'] == null ? value['expirationDate'] : value['expirationDate'].toISOString().substring(0,10),
        'voucherCodes': value['voucherCodes'] == null ? undefined : ((value['voucherCodes'] as Array<any>).map((require('./VoucherCode') as typeof import('./VoucherCode')).VoucherCodeToJSON)),
    };
}

